import React from "react";
import RangeSlider from "./RangeSlider";
import CURRENCY_META from "../components/currencyMeta";

export default function SalaryRange({
  salaryRange,
  setSalaryRange,
  NoPrefSalary,
  setNoPrefSalary,
  salaryCurrency,
}) {
  const isINR = salaryCurrency === "INR";
  const currency = CURRENCY_META[salaryCurrency] || {
    symbol: salaryCurrency,
    name: salaryCurrency,
  };
  return (
    <div>
      {/* <RangeSlider
        label="Salary Range *"
        unit="Lpa"
        min={3}
        max={100}
        step={0.1}
        values={salaryRange}
        setValues={setSalaryRange}
        leftLabel=""
        rightLabel=""
        colorClass="primary"
        noPref={NoPrefSalary}
        setNoPref={setNoPrefSalary}
      /> */}
      <RangeSlider
        label="Salary Range *"
        unit={isINR ? "LPA" : "K"}
        symbol={currency.symbol}
        min={isINR ? 3 : 300}
        max={isINR ? 100 : 10000}
        step={isINR ? 0.1 : 10}
        values={
          isINR ? [salaryRange[0] / 100, salaryRange[1] / 100] : salaryRange
        }
        setValues={(values) =>
          setSalaryRange(isINR ? [values[0] * 100, values[1] * 100] : values)
        }
        leftLabel={`${currency.symbol} ${isINR ? "3 LPA" : "300 K"}`}
        rightLabel={`${currency.symbol} ${isINR ? "100 LPA" : "10000 K"}`}
        colorClass="primary"
        noPref={NoPrefSalary}
        setNoPref={setNoPrefSalary}
      />
    </div>
  );
}
